import Process from "../../components/ProcessCard";
import { motion } from "framer-motion";

const OurServices = () => {
  return (
    <div className="relative px-p83 bg-gradient-to-br from-neutral-950 via-neutral-900 to-neutral-950 bg-cover pb-8 700:pb-12 min-h-[90vh] flex flex-col justify-center overflow-hidden" id="work">
      {/* Background accent */}
      <div className="absolute bottom-0 left-1/2 w-96 h-96 bg-accent-orange/8 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2 pointer-events-none" />
      <motion.h1
        className="text-2xl 500:text-3xl 700:text-4xl text-center pt-8 700:pt-12 pb-6 500:pb-8 font-merry-bold tracking-tight"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        Our <span className="text-primary-500 font-bold">Process</span>
      </motion.h1>

      <motion.div
        className="grid items-center grid-cols-4 gap-4"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.1 }}
        >
          <Process
            src={"/icons/planing-research.svg"}
            alt={"planning"}
            txt={"Planning & Research"}
          />
        </motion.div>
        <motion.p
          className="text-3xl 400:text-4xl 600:text-5xl text-center font-semibold text-primary-200 font-poppins-bold tracking-tight"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          02
        </motion.p>
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.3 }}
        >
          <Process
            src={"/icons/hand-thumbs-up.svg"}
            alt={"Feedback"}
            txt={"Stabilization & Feedback"}
          />
        </motion.div>
        <motion.p
          className="text-3xl 400:text-4xl 600:text-5xl text-center font-semibold text-primary-200 font-poppins-bold tracking-tight"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.4 }}
        >
          04
        </motion.p>
      </motion.div>

      <motion.div
        className="relative my-8"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, delay: 0.3 }}
      >
        <div className="border-t-2 border-primary-300 w-full absolute top-1/2" />
        <div className="flex justify-around relative my-8">
          {[0, 1, 2, 3].map((index) => (
            <motion.div
              key={index}
              className="flex flex-col items-center"
              initial={{ opacity: 0, scale: 0 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: 0.4 + index * 0.1 }}
            >
              <motion.div
                className="w-3 h-3 bg-primary-500 rounded-full relative z-10 shadow-lg"
                animate={{
                  scale: [1, 1.3, 1],
                  opacity: [1, 0.7, 1],
                }}
                transition={{
                  duration: 2,
                  repeat: Infinity,
                  delay: index * 0.5,
                }}
              />
            </motion.div>
          ))}
        </div>
      </motion.div>

      <motion.div
        className="grid items-center grid-cols-4 gap-4"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        <motion.p
          className="text-3xl 400:text-4xl 600:text-5xl text-center font-semibold text-primary-200 font-poppins-bold tracking-tight"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.1 }}
        >
          01
        </motion.p>

        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          <Process
            src={"/icons/design-development.svg"}
            alt={"planning"}
            txt={"Design & Development"}
          />
        </motion.div>

        <motion.p
          className="text-3xl 400:text-4xl 600:text-5xl text-center font-semibold text-primary-200 font-poppins-bold tracking-tight"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.3 }}
        >
          03
        </motion.p>
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.4 }}
        >
          <Process
            src={"/icons/maintenance.svg"}
            alt={"Feedback"}
            txt={"Maintenance & Support"}
          />
        </motion.div>
      </motion.div>
    </div>
  );
};

export default OurServices;
